import React from 'react';
import sendAnalyticEvent from 'services/analytic/analytic-service';
import { Button } from '@tvg/fuse/button';
import { IconShare } from '@tvg/fuse/icon/all';
import appWebhook from '@sd-utility/appwebhook';
import { GetValidMediaUrl } from 'utilities/media/media-util';
import { SiteName } from 'types/Site';
import styles from './ShareButton.module.css';

type Props = {
  productName: string;
  platform: string;
  site: SiteName;
  image: string;
};

function ShareButton(props: Props) {
  const { productName, platform, site, image } = props;

  const mediaUrl = GetValidMediaUrl(site);

  const productImage = `${mediaUrl}/${image}.jpg?$200x200_socialshare$`;

  const handleAppWebHook = () => {
    appWebhook('share', {
      image: productImage,
      link: `${window.location.origin}${window.location.pathname}`,
      product: {
        name: productName,
        url: `${window.location.origin}${window.location.pathname}`,
      },
    });
  };

  const handleShare = () => {
    sendAnalyticEvent({
      gaAction: 'Click',
      gaLabel: 'Share',
    });
    if (platform === 'web') {
      navigator.share({
        url: `${window.location.origin}${window.location.pathname}`,
        title: productName,
      });
    } else {
      handleAppWebHook();
    }
  };

  return (
    <Button
      variant="tertiary"
      onClick={handleShare}
      data-testid="share-icon-container"
      size="medium"
      fullWidth
      className={styles.button}
      icon={
        <IconShare
          title="share"
          width="20px"
          height="20px"
          desc="share icon for share button"
          dataTestId="share-icon"
        />
      }
    >
      Share
    </Button>
  );
}

export default ShareButton;
